export default __webpack_public_path__ + "static/media/GOOGLE_MAPS_API.8da46e92.png";